"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var ChainKey_1 = require("./ChainKey");
var KeyPair_1 = require("../keys/KeyPair");
var SendChain = (function () {
    function SendChain() {
        this.chain_key = new ChainKey_1.default();
        this.ratchet_key = new KeyPair_1.default();
    }
    SendChain.new = function (chain_key, keypair) {
        var sc = ClassUtil_1.default.new_instance(SendChain);
        sc.chain_key = chain_key;
        sc.ratchet_key = keypair;
        return sc;
    };
    SendChain.prototype.encode = function (encoder) {
        encoder.object(2);
        encoder.u8(0);
        this.chain_key.encode(encoder);
        encoder.u8(1);
        return this.ratchet_key.encode(encoder);
    };
    SendChain.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(SendChain);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.chain_key = ChainKey_1.default.decode(decoder);
                    break;
                case 1:
                    self.ratchet_key = KeyPair_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return SendChain;
}());
exports.default = SendChain;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/session/SendChain.js
// module id = 104
// module chunks = 0 1